/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

import { selectCurrentUser } from '@lib/selectors';

const selectGlobal = (state) => state.get('global');
const selectStateForm = (state) => state.get('form');

const makeSelectBroadcastsCount = () =>
  createSelector(
    selectGlobal,
    (state) => state.get('broadcastsCount'),
  );

const makeSelectNewMessage = () =>
  createSelector(
    selectGlobal,
    (state) => state.get('newMessage'),
  );

// TODO: replace `makeSelectCurrentUser` by `selectCurrentUser` everywhere
const makeSelectCurrentUser = () =>
  createSelector(
    selectCurrentUser,
    (currentUser) => currentUser,
  );

const makeSelectDowntimeMessage = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('downtimeMessage'),
  );

const makeSelectLanguages = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('languages'),
  );

const makeSelectError = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('error'),
  );

const makeSelectIntakeFormsSquigglies = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('intakeFormsSquigglies'),
  );

const makeSelectLoading = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('loading'),
  );

const makeSelectMasterUser = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('masterUser'),
  );

const makeSelectNotification = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('notification'),
  );

const makeSelectShowExpiringPasswordAlert = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('showExpiringPasswordAlert'),
  );

const makeSelectWebNotificationType = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('webNotificationType'),
  );

const makeSelectWebNotificationTitle = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('webNotificationTitle'),
  );

const makeSelectWebNotificationData = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('webNotificationData'),
  );

const makeSelectWebNotificationIgnore = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.get('webNotificationIgnore'),
  );

const makeSelectLocationState = () => {
  let prevRoutingState;
  let prevRoutingStateJS;

  return (state) => {
    const routingState = state.get('route'); // or state.route

    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};

const makeSelectFormField = (formName, fieldName) =>
  createSelector(
    selectStateForm,
    (state) => (fieldName ? state.getIn([formName, 'values', fieldName]) : state.getIn([formName, 'values'])),
  );

const makeSelectWidgetUser = () =>
  createSelector(
    selectGlobal,
    (state) => state.get('widgetUser'),
  );

const makeSelectPatientJourney = () =>
  createSelector(
    selectGlobal,
    (state) => state.get('patientJourney'),
  );

export {
  selectGlobal,
  makeSelectBroadcastsCount,
  makeSelectCurrentUser,
  makeSelectDowntimeMessage,
  makeSelectError,
  makeSelectFormField,
  makeSelectIntakeFormsSquigglies,
  makeSelectLanguages,
  makeSelectLoading,
  makeSelectLocationState,
  makeSelectMasterUser,
  makeSelectNewMessage,
  makeSelectNotification,
  makeSelectShowExpiringPasswordAlert,
  makeSelectWebNotificationData,
  makeSelectWebNotificationIgnore,
  makeSelectWebNotificationTitle,
  makeSelectWebNotificationType,
  makeSelectWidgetUser,
  makeSelectPatientJourney,
};
